/**
 * Localization helper for vue
 *
 * Usage: trans(string, optional object)
*/

require('./transHelper');

export default (string, args) => {
    let value = Object.byString(window.i18n, string);

    for (var key in args) {
        value = value.replace(`:${key}`, args[key])
    }
    return value;
}
